import {request} from "./request";
// 核心产品类型列表
export function getTypeName(coreProductTypeId) {
  return request({
    url:'/coreProduct/typeList',
    method:'get',
    params: { coreProductTypeId: coreProductTypeId} // 如果没有提供parentId，则默认为0
  })
}

export function getTypeList(parentId) {
  return request({
    url:'/coreProduct/typeList',
    method:'get',
    params: { parentId: parentId || 0} // 如果没有提供parentId，则默认为0
  })
}


// 核心产品列表
export function getCoreProductList(data) {
  return request({
    url:'/coreProduct/list',
    method:'get',
    params: data,
  })
}

// 核心产品详情
export function getCoreProductDetails(data) {
  return request({
    url:'/coreProduct/'+data,
    method:'get',
  })
}
// 客户案例
export function getProductServiceTypeList(data) {
  return request({
    url:'/productServiceType/list',
    method:'get',
    params: data,
  })
}

// 搜索 核心产品
export function searchCoreProduct(data) {
  return request({
    url:'/coreProduct/list',
    methods:'get',
    params: data,
  })
}
// 搜索 客户案例
export function searchCustomercase(data) {
  return request({
    url:'/customercase/list',
    methods:'get',
    params: data,
  })
}
// 搜索 新闻
export function searchNews(data) {
  return request({
    url:'/news/list',
    methods:'get',
    params: data,
  })
}

// 核心产品列表
// /web/coreProduct/list
// 传递 coreProductTitle coreProductContent  +分页信息


// 客户案例
// /web/customercase/list
// 传递 productServiceTitle productServiceContent +分页信息

// 新闻
// /web/news/list
// 传递  articleTitle articleContent +分页信息



// WEBPACK FOOTER //
// ./src/network/v2revision.js